import dayjs from 'dayjs';

export class FormatUtil {
  static formatCurrency(amount: number, currency: string = 'CAD', locale: string = 'en-CA'): string {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
  }

  static formatDate(date: Date | string, format: string = 'MMMM D, YYYY'): string {
    return dayjs(date).format(format);
  }

  static formatPhone(phone: string): string {
    if (!phone) return '-';
    const digits = phone.replace(/\D/g, '');
    const local = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
    if (local.length !== 10) return phone;
    return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  }
}